import { useQuery } from "@tanstack/react-query";
import { fetchQuizModes } from "../services/quizModeService";

function normalizeQuizMode(item) {
  const dataKey = String(item?.data_key || "").toUpperCase();

  return {
    id: dataKey || item?.name || "P",
    dataKey,
    langShortName: item?.lang_short_name || "",
    title: item?.name || "Practice Mode",
    description: item?.description || "",
    icon: dataKey === "E" ? "bi-layers-fill" : "bi-stopwatch-fill",
    iconClass: dataKey === "E" ? "evaluation-icon" : "practice-icon",
  };
}

export function useQuizModes(params = {}, options = {}) {
  return useQuery({
    queryKey: ["quizModes", params],
    queryFn: async () => {
      const { payload } = await fetchQuizModes(params);
      const quizModes = Array.isArray(payload?.quiz_modes) ? payload.quiz_modes : [];

      return quizModes.map(normalizeQuizMode);
    },
    enabled: Boolean(params?.quiz_id) && (options.enabled ?? true),
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    placeholderData: (previousData) => previousData ?? [],
  });
}
